import type { APIService } from '@captivateiq/assistant';

import { getRequest, postRequest } from 'services/apiRequests';

export class TQAPIServiceAdapter implements APIService {
  private csrfToken: string;

  constructor(csrfToken: string) {
    this.csrfToken = csrfToken;
  }

  async get<T>(url: string, params?: Record<string, any>): Promise<T> {
    return getRequest<Record<string, any>, T>(url, params ?? undefined);
  }

  async post<T>(url: string, data: any): Promise<T> {
    return postRequest<any, T>(url, data, this.csrfToken);
  }
}
